




























import { UiIconButton } from './keen-ui';

export default {
  name: 'epb-aside',
  props: {
    collapsible: Boolean,
    collapsed: Boolean
  },
  components: {
    UiIconButton
  },
  computed: {
    expanded: function (): boolean {
      return (!this.collapsible || !this.collapsed);
    }
  }
};
